import { render, staticRenderFns } from "./ProjectActorDialogBody.vue?vue&type=template&id=732351df&scoped=true&"
import script from "./ProjectActorDialogBody.vue?vue&type=script&lang=js&"
export * from "./ProjectActorDialogBody.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActorDialogBody.vue?vue&type=style&index=0&id=732351df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732351df",
  null
  
)

export default component.exports